import { VirtualTable } from "../../components/tables";
import { StandardTableSortablePropertyHeader } from "../../components/tables/StandardTable";
import { ThemedSpan } from "../../components/utilities";
import { ErrorMessage, ErrorMessageWrapper } from "../../components/messages";
import { useAuth } from "react-oidc-context";
import ClientApplicationsGridTableRow from "./components/ClientApplicationsGridTableRow";
import useClientApplications from "./hooks/useClientApplications";
import { useClientContext } from "../../hooks/ClientContext";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";

const ClientApplicationsGrid = ({ loadingLines = 4 }) => {

    const auth = useAuth();
    const { user: { profile: { roles } } } = auth;

    const {id} = useClientContext();

    const {
        results,
        sort,
        totalCount,
        isError,
        error,
        isNextPageLoading,
        clear,
        isRowLoaded,
        loadMore,
        sortTable
    } = useClientApplications(id);


    if (isError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={clear} />
        </ErrorMessageWrapper>
    }

    return (
        <>
            <VirtualTable
                enableScrollTracking={false}
                row={ClientApplicationsGridTableRow}
                header={
                    <thead>
                        <tr>
                            <StandardTableSortablePropertyHeader
                                property="status"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Status
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="applicationStatusDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Status Date
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="designationName"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Designation
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="adviserName"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Adviser
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="providerName"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Provider
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="providerReference"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Provider Ref
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="amount"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Amount
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="description"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Description
                            </StandardTableSortablePropertyHeader>
                        </tr>
                    </thead>
                }
                footer={
                     <TableRecordCountDisplayFooter 
                        totalCount={totalCount}
                        isNewRecordsDisplayed={false}
                        newRecordsSinceCache={0}
                        reload={clear}
                        spanLeft={5}
                    />
                }
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={50}
                isLoading={isNextPageLoading}
                itemCount={totalCount === results.length ? totalCount : results.length + loadingLines}
                itemData={results}
            />
        </>
    );
};

export default ClientApplicationsGrid;
